import React from 'react';

function Arrow(props) {
  const disabled = props.disabled ? ' arrow--disabled' : '';
  return (
    <div
      className={`cursor-pointer border border-solid   inline-block rounded-full p-5   ${
        disabled ? 'invisible' : 'visible'
      }`}
      onClick={props.onClick}
    >
      <svg
        className={`bts-slide-arrow text-[#929292] arrow ${
          props.left ? 'arrow--left' : 'arrow--right'
        } `}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={'12px'}
        height={'12px'}
      >
        {props.left && (
          <path
            d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"
            strokeWidth="0.5"
            fill="#929292"
          />
        )}
        {!props.left && (
          <path
            d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"
            strokeWidth="0.5"
            fill="#929292"
          />
        )}
      </svg>
    </div>
  );
}

export const Navigation = ({
  current,
  totalPage,
  leftOnClick,
  leftDisabled,
  rightOnClick,
  rightDisabled,
}) => {
  return (
    <div
      className={
        'text-center mt-[10%] sm:mt-[1%] flex align-center items-center justify-center'
      }
    >
      {totalPage > 1 && (
        <Arrow left onClick={leftOnClick} disabled={leftDisabled} />
      )}
      {totalPage > 0 && (
        <div className=" text-[#929292]  w-[150px]">
          {current} <span className="px-3">/</span>
          {totalPage}
        </div>
      )}
      {totalPage > 1 && (
        <Arrow onClick={rightOnClick} disabled={rightDisabled} />
      )}
    </div>
  );
};

export default Navigation;
